<template>
  <div id="app">
    <layout/>
  </div>
</template>
<script>
import Layout from './views/Layout'
export default {
  name:'app',
  components:{
    Layout
  },
  watch:{
    $route(){
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }
}
</script>

<style lang="scss">
p{
  margin: 0;
}
a{
  text-decoration: none;
}
.container{
  width: 1000px;
  margin: 0 auto;
}
.banner{
  width: 100%;
  img{
    width: 100%;
    display: block;
  }
}
.video-js{
  width:100% !important;
  height: 45vw !important;
}
//中型屏幕
@media only screen and (max-width: $screen-lg-min){
    .container{
      width: $screen-sm-min;
      margin: 0 auto;
    }
} 
//移动端和ipad
@media only screen and (max-width: $screen-sm-min){
    .container{
      width: 100%;
      margin: 0 auto;
    }
    .banner{
      width: 100%;
      height: 200px;
      img{
        @include imgCover;
        display: block;
      }
    }
} 



</style>
